import type { Page } from '@/domain/model/Page';
import type { CalendarioEvento, UpsertCalendarioEventoCommand } from '@/domain/model/CalendarioEvento';
import type { CalendarioEventoGateway, ListCalendarioParams } from '@/application/port/out/CalendarioEventoGateway';
import type {
  ListCalendarioEventosUseCase, CreateCalendarioEventoUseCase,
  UpdateCalendarioEventoUseCase, DeleteCalendarioEventoUseCase,
} from '@/application/port/in/CalendarioEventoUseCase';

export class ListCalendarioEventos implements ListCalendarioEventosUseCase {
  constructor(private readonly g: CalendarioEventoGateway) {}
  execute(params: ListCalendarioParams): Promise<Page<CalendarioEvento>> { return this.g.list(params); }
}
export class CreateCalendarioEvento implements CreateCalendarioEventoUseCase {
  constructor(private readonly g: CalendarioEventoGateway) {}
  execute(cmd: UpsertCalendarioEventoCommand): Promise<CalendarioEvento> { return this.g.create(cmd); }
}
export class UpdateCalendarioEvento implements UpdateCalendarioEventoUseCase {
  constructor(private readonly g: CalendarioEventoGateway) {}
  execute(id: string, cmd: UpsertCalendarioEventoCommand): Promise<CalendarioEvento> { return this.g.update(id, cmd); }
}
export class DeleteCalendarioEvento implements DeleteCalendarioEventoUseCase {
  constructor(private readonly g: CalendarioEventoGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
